/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormGroup } from "react-bootstrap-3";
import moment from "moment";
import styled from "styled-components";

const Container = styled.div`
  max-width: 300px;

  .react-datepicker__month-container ~ .react-datepicker__month-container .react-datepicker__day-names {
      margin-top: 23px !important;
  }
`;

function handleOnChange({ onChange, value, fieldName, dateFormat }) {
  onChange({
    value: value ? moment(value).format(dateFormat) : null,
    field: fieldName,
  });
}

function DatePickerGroup({
  value,
  hasErrors,
  onChange,
  field,
  disabled,
  formValues,
  minDate = "",
  isClearable = true,
}) {
  const {
    fieldName,
    placeholder,
    dateFormat = "YYYY-MM-DD",
    displayDateFormat = "yyyy-MM-dd",
    isRange,
  } = field;
  const date = value ? moment(value, dateFormat).toDate() : undefined;

  const { selectsStart = undefined, selectsEnd = undefined, startField, endField } = field;

  let startDate,
    endDate = null;
  if (isRange) {
    const startDateValue = formValues.hasOwnProperty(startField) && formValues[startField];
    const endDateValue = formValues.hasOwnProperty(endField) && formValues[endField];
    startDate = startDateValue ? moment(startDateValue, dateFormat).toDate() : undefined;
    endDate = endDateValue ? moment(endDateValue, dateFormat).toDate() : undefined;
  }

  return (
    <Container className={`DatePicker ${field.className}`}>
      <FormGroup>
        <DatePicker
          selected={date}
          dateFormat={displayDateFormat}
          placeholderText={placeholder}
          disabled={disabled}
          className={`form-control ${hasErrors && "parsley-error"}`}
          onChange={value =>
            handleOnChange({
              value,
              fieldName,
              dateFormat,
              onChange,
            })
          }
          selectsStart={selectsStart}
          selectsEnd={selectsEnd}
          startDate={startDate}
          endDate={endDate}
          monthsShown={2}
          isClearable={!disabled && isClearable}
          minDate={minDate && new Date(minDate)}
          showMonthDropdown
          showYearDropdown
        />
      </FormGroup>
    </Container>
  );
}

DatePickerGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DatePickerGroup;
